<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <div class="mb-2">
            {{ date }}
        </div>
        <v-card class="mb-4" :loading="loading">
            <v-card-title>
                {{$t('Detalles del pedido')}} #{{ numberOrder }}
                <small class="grey--text ml-3">{{$t('IP del cliente')}}: {{ ipAddress }}</small>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    :href="`/admin/print-presale/${order}`"
                    target="_blank"
                ><v-icon left>mdi-file-pdf-box</v-icon> {{$t('Imprimir')}}</v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">
                            {{$t('Datos cliente')}}
                            <v-btn
                                icon
                                @click="preventId=order, dialogEditPresale=true"
                            >
                                <v-icon color="grey">
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                        </div>
                        <div>
                            {{ clientName }}
                            <br>
                            <a :href="`https://api.whatsapp.com/send?phone=${phonecode}${phoneNumber}`" target="_blank">
                                {{ phoneNumber }}
                            </a>
                        </div>
                        <div class="text-h6 mt-3">{{$t('Datos facturación')}}</div>
                        <div>
                            <strong>{{$t('Razón social')}}:</strong> {{ fullName }}
                            <br>
                            <strong>{{$t('NIT/CI')}}:</strong> {{ document }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Dirección de entrega')}}</div>
                        <div>
                            <a :href="`https://www.google.com/maps/place/${lat},${lng}`" target="_blank">{{$t('Ver mapa')}}</a>
                            <br>
                            {{ addressMap }}
                        </div>
                        <div class="text-h6">{{$t('Saldo')}}</div>
                        <div>
                            {{ money }} {{ total-balance }}
                            <v-btn
                                color="primary"
                                small
                                @click="dialogBalance=!dialogBalance"
                                :disabled="total-balance<=0"
                            >{{$t('Editar Saldo')}}</v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Estado')}}</div>
                        <div>
                            <v-select
                                :items="itemsStates"
                                :label="$t('Estado')"
                                outlined
                                dense
                                v-model="state"
                            ></v-select>
                            <div class="text-right">
                                <v-btn
                                    color="primary"
                                    small
                                    @click="updateState"
                                    :loading="loading"
                                >{{$t('Actualizar estado')}}</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card>
            <v-card-title>
                {{$t('Nota de venta')}}
                <v-btn
                    style="margin-left: 2em;"
                    color="primary"
                    small
                    @click="dialogProducts = true"
                >
                    {{$t('Agregar productos')}}
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Producto')}}
                            </th>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Precio')}}
                            </th>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Cantidad')}}
                            </th>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Total')}}
                            </th>
                            <th class="text-right grey--text text--lighten-1">
                                {{$t('Acciones')}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in cart" :key="i">
                            <td class="text-left">{{ item.name }}</td>
                            <td class="text-left">{{ money }} {{ item.price }}</td>
                            <td class="text-left">
                                <v-text-field
                                    v-if="tmpEdit && item.id==tmpProdId"
                                    v-model="tmpQuantity"
                                    label="Cantidad"
                                    outlined
                                    dense
                                    hide-details
                                    type="number"
                                    style="width: 100px;"
                                ></v-text-field>
                                <span v-else>
                                    x{{ item.pivot.quantity }}
                                </span>
                            </td>
                            <td class="text-left">
                                <!-- <v-text-field
                                    v-if="tmpEdit && item.id==tmpProdId"
                                    v-model="tmpPrice"
                                    label="Precio"
                                    outlined
                                    dense
                                    hide-details
                                    style="width: 100px;"
                                ></v-text-field>
                                <span v-else>
                                    {{ money }} {{ (+item.pivot.price) }}
                                </span> -->
                                <span v-if="tmpEdit && item.id==tmpProdId">
                                    {{ money }} {{ (+item.price)*(+tmpQuantity) }}
                                </span>
                                <span v-else>
                                    {{ money }} {{ (+item.pivot.price) }}
                                </span>
                            </td>
                            <td class="text-right" style="width: 150px;">
                                <div class="d-flex justify-end" v-if="tmpEdit && item.id==tmpProdId">
                                    <v-btn
                                        color="primary"
                                        small
                                        class="mr-1"
                                        :loading="loadingEdit"
                                        @click="saveUpdateItem(item.price)"
                                    >{{$t('Guardar')}}</v-btn>
                                    <v-btn
                                        color="error"
                                        small
                                        outlined
                                        :loading="loadingEdit"
                                        @click="tmpEdit=false"
                                    >{{$t('Cancelar')}}</v-btn>
                                </div>
                                <div class="d-flex justify-end" v-else>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="tmpEdit=!tmpEdit, tmpQuantity=item.pivot.quantity, tmpPrice=item.pivot.price, tmpProdId=item.id"
                                            >
                                                <v-icon color="grey">
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{$t('Editar')}}</span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="deleteItem(item.id)"
                                            >
                                                <v-icon color="grey">
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{$t('Eliminar')}}</span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="openDetails(item, i)"
                                            >
                                                <v-icon color="grey">
                                                    mdi-eye
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{$t('Ver')}}</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h6">{{$t('Subtotal')}} {{ money }}</strong>
                            </td>
                            <td>
                                <strong class="text-h6">{{ money }} {{ total }}</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h5">{{$t('Total')}} {{ money }}</strong>
                            </td>
                            <td>
                                <strong class="text-h5">{{ money }} {{ (total>0)?total:0 }}</strong>
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>
                <v-card-title>
                    {{ nameProd }}
                </v-card-title>

                <v-card-text class="py-5 px-0">
                    <div class="px-5 mb-5" v-if="descriptionProd!='null'" v-html="descriptionProd"></div>

                    <v-divider></v-divider>

                    <div class="px-5 pt-5" v-if="dataExtra!=''">
                        <strong>Dato extra</strong> <br>
                        {{ dataExtra }}
                    </div>

                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="6">
                            <small>Cantidad</small>
                            <div class="text-h5">x{{ quantity }}</div>
                        </v-col>
                        <v-col cols="6">
                            <small>Total a pagar</small>
                            <div class="text-h5">{{ money }} {{ price }}</div>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogBalance"
            width="350"
        >
            <v-card>
                <v-card-title>
                    {{$t('Actualizar Saldo')}}
                </v-card-title>

                <v-card-text>
                    <div class="mb-3">
                        <strong>{{$t('Saldo')}}:</strong>
                        {{ money }} {{ total-balance }}
                    </div>
                    <div class="mb-3">
                        <strong>{{$t('Acuenta')}}:</strong>
                        <v-text-field
                            v-model="upBalance"
                            :label="$t('A cuenta')"
                            outlined
                            dense
                            hide-details
                            type="number"
                            min="0"
                            :max="total-balance"
                            style="max-width: 120px;"
                        ></v-text-field>
                    </div>
                    <div class="mb-3">
                        <strong>{{$t('Total saldo')}}:</strong>
                        {{ money }} {{ (total-balance) - upBalance }}
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogBalance=false"
                        :loading="loading"
                    >{{$t('Cancelar')}}</v-btn>
                    <v-btn
                        color="primary"
                        @click="updateBalance"
                        :loading="loading"
                    >{{$t('Actualizar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- dialog edit -->
        <v-dialog
            v-model="dialogEditPresale"
            max-width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <edit-presale v-if="dialogEditPresale" :presale-id="order" :slug="slug" :money="money" @close-dialog="dialogEditPresale = false"></edit-presale>
        </v-dialog>
        <!-- end dialog -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

        <v-dialog
            v-model="dialogProducts"
            width="800"
        >
            <products-presale :slug="this.slug" :onAddProduct="handleAddProduct" :close="() => dialogProducts=false"  />
        </v-dialog>
    </v-container>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Preventas',
                    disabled: false,
                    href: '/admin/presales',
                },
                {
                    text: 'Preventa',
                    disabled: true,
                    href: '',
                }
            ],
            // data
            numberOrder: null,
            listAddressOfPickUp: [],
            fullName: '',
            clientName: '',
            phoneNumber: '',
            phonecode: '',
            remarkOrder: false,
            commentOrder: '',
            itemsStates: ['Pendiente', 'En tránsito', 'Completado', 'Reembolsado', 'Fallido'],
            state: '',
            date: null,
            ipAddress: '',
            document: '',
            addressMap: '',
            lat: null,
            lng: null,
            // cart
            cart: {},
            total: 0,
            balance: 0,
            // open product
            loadProd: true,
            dialogProd: false,
            bannerProd: '',
            nameProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: '',
            respOnlyVal: 0,
            // balance
            dialogBalance: false,
            upBalance: 0,
            // editar
            loadingEdit: false,
            tmpEdit: false,
            tmpProdId: '',
            tmpQuantity: 0,
            // tmpPrice: 0,
            dialogEditPresale: false,
            dialogProducts: false,
        }
    },
    props: ['order', 'money','slug'],
    watch: {
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = ''
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        }
    },
    mounted() {
        this.getSingleProduct()
    },
    methods: {
        /**
         * Single product
         */
        async getSingleProduct () {
            this.overlay = true
            await axios.post(`/admin/single-presale/${this.order}`, {})
            .then(response => {
                // console.log(response)
                this.numberOrder = response.data.number
                const d = new Date(response.data.created_at)
                this.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()

                // datos cliente
                this.fullName = response.data.business_name
                this.clientName = response.data.client.name+' '+response.data.client.lastname
                this.phoneNumber = (response.data.client.phone)?response.data.client.phone:''
                this.phonecode = (response.data.client.code)?response.data.client.code.replace('+', ''):''

                // estado
                this.state = response.data.state
                this.ipAddress = response.data.ip_address

                // cart
                this.cart = response.data.products
                this.total = response.data.total

                // invoice
                this.document = response.data.document

                //
                this.addressMap = response.data.address_map
                this.lat = response.data.lat_map
                this.lng = response.data.lng_map

                this.balance = response.data.balance

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },

        /**
         * update state
         */
        async updateState() {
            this.loading = true
            await axios.post(`/admin/up-presale/${this.order}`, {state: this.state})
            .then((response) => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Estado actualizado con éxito.'))
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            })
        },

        // open details
        openDetails(prod, index) {
            this.tmpIndex = index
            this.loadProd = true
            this.dialogProd = true
            axios.get(`/show-product/${prod.id}`)
            .then((response) => {
                // console.log(response);
                this.optionsProd = []
                this.respMultipleVal = 0

                this.respOnlyVal = 0

                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.descriptionProd = response.data.description
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price

                // default data
                this.dataExtra = prod.extra
                this.quantity = prod.quantity
                this.respMultiple = prod.multi
                this.respOnly = prod.only

                setTimeout(() => {
                    this.loadProd = false
                }, 500);
            })
            .catch((error) => {
                console.log(error);
            })
        },

        /**
         * balace
         */
        async updateBalance() {
            this.loading = true
            await axios.post(`/admin/up-balance/${this.order}`, {balance: this.upBalance})
            .then((response) => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Saldo actualizado con éxito.'))
                    this.dialogBalance = false
                    this.getSingleProduct()
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            })
        },

        /**
         * eliminar
         */
        deleteItem(id) {
            this.$confirm(
                this.$t('Se eliminará permanentemente del sistema y afectara al total de la venta.'),
                this.$t('¿Eliminar producto?'),
                'question', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('Eliminar'),
                cancelButtonText: this.$t('Cancelar'),
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/presale-delete-prod/${this.order}?prod=${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', this.$t('Producto eliminado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                            this.getSingleProduct()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },
        /**
         * actualizar item
         */
        saveUpdateItem(price) {
            this.$confirm(
                '',
                this.$t('¿Estas seguro de actualizar este item?'),
                'question', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('Actualizar'),
                cancelButtonText: this.$t('Cancelar'),
            }).then(res => {
                if (res) {
                    this.loadingEdit = true
                    axios.post(`/admin/presale-update-prod/${this.order}`, {
                        prod: this.tmpProdId,
                        quantity: this.tmpQuantity,
                        price: price
                    })
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', this.$t('Actualizado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                            this.getSingleProduct()
                            this.tmpEdit = false
                            this.tmpProdId = ''
                        }
                        this.loadingEdit = false
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                        this.loadingEdit = false
                    })
                }
            });
        },

        /**
         * Some
         */
        async handleAddProduct(selprods) {
            let prods = selprods.filter((p) => p.quantity > 0);

            try {
                prods.forEach(async (prod) => {
                    let res = await axios.post(`/admin/presale-add-prods/${this.order}`, {
                        products: prods.map(p => ({
                            product_id: p.id,
                            price: (p.price * p.quantity),
                            quantity: p.quantity,
                        }))
                    });
                });
                this.getSingleProduct();
            } catch (error) { }
        }
    },
}
</script>
